import Indicator from './Indicator.vue';

export default Indicator;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/indicator/index.ts